import React from "react";
import { Header, Button } from "lantmannen-common-widget";
import { withRouter } from "react-router-dom";
import logo from "assets/lm-favicon-21.png";

const DefaultHeader = ({ location, history, ...props }) => {
  function goBack() {
    if (location.pathname !== "/") {
      history.goBack();
    }
  }
  let action = location.pathname !== "/" && (
    <Button onClick={goBack} small text={"Tillbaka"} />
  );
  return <Header action={action} icon={logo} title={"Ogräsbehandling"} />;
};

export default withRouter(DefaultHeader);
